import { type ReactNode } from 'react'
import { useLocation, useNavigate } from 'react-router-dom-v5-compat'
import { ButtonFill, Flex, PageTemplate } from '@npco/zeller-design-system'

import { ROOT } from 'const/routes'
import { translate } from 'utils/translations'
import { Breadcrumbs } from 'components/Breadcrumbs/Breadcrumbs'
import { MobileNavHeader } from 'components/Sidebar/components/MobileNavHeader/MobileNavHeader'

interface Props {
  children: ReactNode
}

export const UsersLayout = ({ children }: Props) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  return (
    <PageTemplate
      HeaderMobileRow={<MobileNavHeader />}
      HeaderPrimaryRow={
        <PageTemplate.HeaderPrimaryRow>
          <Flex
            justifyContent="space-between"
            alignItems="center"
            width={1}
            height="48px"
          >
            <Flex>
              <Breadcrumbs />
            </Flex>
            {pathname === ROOT.PORTAL.SETTINGS.USERS.path && (
              <ButtonFill
                onClick={() =>
                  navigate(ROOT.PORTAL.SETTINGS.USERS.USER_CREATE_TYPE.path)
                }
              >
                {translate('page.settings.users.addUser')}
              </ButtonFill>
            )}
          </Flex>
        </PageTemplate.HeaderPrimaryRow>
      }
    >
      {pathname !== ROOT.PORTAL.SETTINGS.USERS.path ? (
        <PageTemplate.Section>{children}</PageTemplate.Section>
      ) : (
        children
      )}
    </PageTemplate>
  )
}
